import React from "react";

const URL_PATTERN = /((?:https?:\/\/|www\.)[^\s<]+|(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:com|net|org|io|co|us|info|biz|app|dev|site|online|xyz|me|gg|casino|games|live|club|shop|vip)(?:\/[^\s<]*)?)/gi;
const TRAILING_PUNCTUATION = /[.,!?;:)\]]+$/;

function splitTrailingPunctuation(value) {
  const match = value.match(TRAILING_PUNCTUATION);
  if (!match) return [value, ""];
  return [value.slice(0, -match[0].length), match[0]];
}

function hrefFor(value) {
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
}

export default function LinkifiedText({ text, linkClassName = "" }) {
  const value = String(text || "");
  const parts = [];
  let lastIndex = 0;

  value.replace(URL_PATTERN, (match, _url, offset) => {
    if (offset > lastIndex) {
      parts.push({ type: "text", value: value.slice(lastIndex, offset) });
    }
    const [url, trailing] = splitTrailingPunctuation(match);
    if (url) {
      parts.push({ type: "link", value: url });
    }
    if (trailing) {
      parts.push({ type: "text", value: trailing });
    }
    lastIndex = offset + match.length;
    return match;
  });

  if (lastIndex < value.length) {
    parts.push({ type: "text", value: value.slice(lastIndex) });
  }

  if (!parts.length) return value;

  return (
    <>
      {parts.map((part, index) => (
        part.type === "link" ? (
          <a
            key={`${part.value}-${index}`}
            href={hrefFor(part.value)}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
          >
            {part.value}
          </a>
        ) : (
          <React.Fragment key={`${index}-${part.value}`}>{part.value}</React.Fragment>
        )
      ))}
    </>
  );
}
